'use client';

import {styled} from "@mui/material/styles";

const SearchContainer = styled('div')(({theme}) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    border: '1px solid ' + theme.palette.custom?.border,
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
        boxShadow: `0 1px 3px ${theme.palette.custom?.border}`,
    },
    margin: theme.spacing(.5),
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
        width: 'auto',
    },
}));

export default SearchContainer;
